import { getToken } from "../../setup/api";

export default {
  quizes: [],
  final_quiz: [],
  pagination: []
};
